<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{
      "title.document_management_list_uppercase" | translate
      }}</mat-card-title>
  </mat-card-header>

  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion>
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ "title.search_condition" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm" [formGroup]="searchDocumentForm" class="pb-3" (ngSubmit)="onClickBtnFilter()"
          (keydown.enter)="onClickBtnFilter()">
          <div class="row">
            <div class="col-4">
              <!-- ten/ ma mau-->
              <mat-form-field class="w-100">
                <input (focusout)="
                    focusOut('codeOrNameContains')
                  " #focusInput matInput type="text" [placeholder]="
                    'document_template.lbl_name_or_code' | translate
                  " name="documentName" maxlength="200" autocomplete="off" formControlName="codeOrNameContains"
                  (keydown.enter)="$event.preventDefault()" />
                <button mat-button *ngIf="searchDocumentForm?.controls?.codeOrNameContains?.value" type="button"
                  matSuffix mat-icon-button aria-label="Clear" (click)="clearData('codeOrNameContains')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-4">
              <!-- loai hop dong -->
              <mat-form-field class="w-100">
                <mat-select id="type" name="type" [placeholder]="'document_template.lbl_document_type' | translate"
                  formControlName="typeContains" (ngModelChange)="onClickBtnFilter()">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="searchTypeCtrl" placeholderLabel="Nhập loại hợp đồng/văn bản"
                      [searching]="loadingSearchType" noEntriesFoundLabel="Không có kết quả!"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let type of listTypes | async" [value]="type.id">
                    {{ type.name }}
                  </mat-option>
                </mat-select>
                <button mat-button *ngIf="searchDocumentForm?.controls?.typeContains?.value" type="button" matSuffix
                  mat-icon-button aria-label="Clear" (click)="clearData('typeContains')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-4">
              <!-- trang thai -->
              <mat-form-field class="w-100">
                <mat-select id="status" name="status" [placeholder]="'document_template.lbl_status' | translate"
                  formControlName="statusEquals" (ngModelChange)="onClickBtnFilter()">
                  <mat-option value="null">
                    {{
                    "system_document_template.cbx_document_status.cbx_document_status_select_all"
                    | translate
                    }}
                  </mat-option>
                  <mat-option value="ACTIVE">
                    {{
                    "system_document_template.cbx_document_status.cbx_document_status_active"
                    | translate
                    }}
                  </mat-option>
                  <mat-option value="INACTIVE">
                    {{
                    "system_document_template.cbx_document_status.cbx_document_status_inactive"
                    | translate
                    }}
                  </mat-option>
                  <mat-option value="DRAFT">
                    {{ "document_template.lbl_draft" | translate }}
                  </mat-option>
                </mat-select>
                <button mat-button *ngIf="documents.status" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="documents.status = ''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <button mat-stroked-button color="primary" type="submit">
                <mat-icon class="mr-0" style="font-weight: 900">search</mat-icon>
                {{ "search_form.search" | translate }}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
          <span>{{ "title.search_result" | translate }} ({{
            paginate.totalRow
            }})</span>
          <div class="pull-right">
            <button class="mr-2" mat-stroked-button color="primary" type="button"
              *ngIf="!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM)"
              (click)="onClickSearchDocument()" [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">search</mat-icon>{{ "button.search_document" | translate }}
            </button>
            <button class="pull-right" mat-stroked-button color="primary" type="button"
              *ngIf="!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM)"
              (click)="onClickCreateField()" [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">add_circle</mat-icon>{{ "button.create_document" | translate }}
            </button>
          </div>
        </mat-panel-title>
        <div>
          <mat-table [dataSource]="parentDataSource" matSort>
            <!-- số thứ tự Column -->
            <ng-container matColumnDef="stt">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">{{ "headertable.stt" |
                translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element; let i = index" class="mat-cell-non-boder-right-bottom">
                {{ paginate.currentPage * paginate.pageSize + i + 1 }}
              </mat-cell>
            </ng-container>
            <!-- Tên mẫu tài liệu Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">{{ "headertable.template_name"
                | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element, let i=index" [matTooltip]="displayTooltip(element.name, i, 'nameDoc')"
                class="mat-cell-non-boder-right-bottom cell">
                <span class="fix-width fw-100 nameDoc">{{ element.name }}</span>
              </mat-cell>
            </ng-container>

            <!-- Mã mẫu tài liệu Column -->
            <ng-container matColumnDef="code">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">{{ "headertable.template_code"
                | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element, let i=index" [matTooltip]="displayTooltip(element.code, i, 'codeDoc')"
                class="mat-cell-non-boder-right-bottom">
                <span class="fix-width fw-100 codeDoc">{{ element.code }}</span>
              </mat-cell>
            </ng-container>

            <!-- Loại hợp đồng Cha Column -->
            <ng-container matColumnDef="type">
              <mat-header-cell *matHeaderCellDef>{{ "headertable.document_type_name" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ renderServiceType(element.serviceType) }}
              </mat-cell>
            </ng-container>

            <!-- Trạng thái Column -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="text-center mat-cell-non-boder-right-bottom">
                {{ "headertable.status" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                [matTooltip]="getTooltip(element)">
                <button [disabled]="commonService.getIsLockedEnterprise()" mat-icon-button type="button"
                  (click)="changeStatus(element)" *ngIf="!element.isDraft">
                  <mat-icon *ngIf="!element.status">lock</mat-icon>
                  <mat-icon *ngIf="element.status">lock_open</mat-icon>
                </button>

                <mat-icon style="color: grey; width: auto" *ngIf="element.isDraft">
                  border_color</mat-icon>
              </mat-cell>
            </ng-container>

            <!-- Tác động Column -->
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="text-center">
                {{ "headertable.action_header" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="text-center">
                <button mat-icon-button type="button" [disabled]="element.isDraft" (click)="preview(element)">
                  <mat-icon [matTooltip]="getTooltipPreview(element)">visibility</mat-icon>
                </button>
                <!-- <button
                  mat-icon-button
                  type="button"
                  *ngIf="element.isDraft"
                  style="opacity: 0; cursor: default"
                >
                  <mat-icon>visibility</mat-icon>
                </button> -->
                <button mat-icon-button type="button"
                  *ngIf="!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM)"
                  (click)="editDocument(element)" [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon matTooltip="{{
                      'document_template.tooltip_edit' | translate
                    }}">mode_edit</mat-icon>
                </button>
                <button mat-icon-button
                  *ngIf="!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM)"
                  (click)="copyDocumentTemplate(element)" [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon type="button" matTooltip="{{
                      'enterprise_contract.buttons.copy' | translate
                    }}">file_copy</mat-icon>
                </button>
                <button [disabled]="commonService.getIsLockedEnterprise()" mat-icon-button type="button"
                  (click)="deleteDocument(element)">
                  <i [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}" class="fa fa-trash"
                    style="font-size: 20px;" aria-hidden="true" matTooltip="{{
                      'document_template.tooltip_delete' | translate
                    }}"></i>
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns" class="element-row">
            </mat-row>
          </mat-table>

          <!-- Pagination -->
          <app-pagination [(paginate)]="paginate" (pageChange)="onPageChange($event.page, $event.pageSize)">
          </app-pagination>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
